import { HttpClient } from '@angular/common/http';
import { Injectable, Optional } from '@angular/core';
import { HttpCacheService } from 'src/app/core/services/HttpCacheService';

@Injectable({
  providedIn: 'root'
})
export class GoogleiconPickerService {

  private _iconMeta: any = [];
  //return Icon Meta
  get iconMeta() { return this._iconMeta; }
  private _topTenPopularIcons: any = [];
  //return Top 10 Poplar Icons
  get topTenPopularIcons() { return this._topTenPopularIcons }
  iconResult: any;;
  private fetchPromise: Promise<any> | null = null;

  constructor(@Optional() private _http: HttpClient, private httpCs: HttpCacheService,) { }

  //get Icon Meta from assets
  async getIconsMeta() {
    // If there's already a fetch in progress, return the existing promise
    // This prevents multiple concurrent HTTP requests
    if (this.fetchPromise) {
      return this.fetchPromise.then(() => this.iconResult.icons);
    }
    
    let result: any = {};
    try {
      // Create a new promise for this fetch operation
      this.fetchPromise = new Promise(async (resolve, reject) => {
        try {
          // Only fetch if we don't already have the data
          if (!this.iconResult) {
            this.iconResult = await this.httpCs.get(`assets/icon/iconmeta.json`, {}, {"cacheKey": `iconpicker`});
          }
          result.icons = this._iconMeta = this.iconResult.icons;
          this._topTenPopularIcons = result.icons.slice(0, 10);
          resolve(this.iconResult.icons);
        } catch (error) {
          console.error("Error fetching icon metadata:", error);
          reject(error);
        } finally {
          // Clear the promise reference after completion (success or failure)
          // This allows future calls to create a new promise if needed
          setTimeout(() => {
            this.fetchPromise = null;
          }, 0);
        }
      });
      
      return await this.fetchPromise;
    } catch (error) {
      console.error("Error in getIconsMeta:", error);
      return error;
    }
  }
}
